module.exports = __webpack_public_path__ + "img/icon-menu-rocket.00f048e2.svg";